import { useEffect, useRef } from "react";

export function useAutoHorizontalScroll({
  speed = 0.5,
  pauseOnHover = true,
  forceMinWidth = true, 
}: {
  speed?: number;
  pauseOnHover?: boolean;
  forceMinWidth?: boolean;
}) {
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const animationRef = useRef<number | null>(null);
  const isPaused = useRef(false);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    function ensureScrollable() {
      if (
        forceMinWidth &&
        window.innerWidth <= 700 &&
        container &&
        container.scrollWidth <= container.clientWidth
      ) {
        container.style.minWidth = "200vw";
      } else if (container) {
        container.style.minWidth = "";
      }
    }
    ensureScrollable();

    function step() {
      if (!container) return;
      if (isPaused.current) {
        animationRef.current = requestAnimationFrame(step);
        return;
      }
      if (container.scrollLeft + container.clientWidth >= container.scrollWidth) {
        container.scrollLeft = 0;
      } else {
        container.scrollLeft += speed;
      }
      animationRef.current = requestAnimationFrame(step);
    }

    animationRef.current = requestAnimationFrame(step);

    let cleanup = () => {};
    // if (pauseOnHover && container) {
    //   const onMouseEnter = () => { isPaused.current = true; };
    //   const onMouseLeave = () => { isPaused.current = false; };
    //   container.addEventListener("mouseenter", onMouseEnter);
    //   container.addEventListener("mouseleave", onMouseLeave);
    //   cleanup = () => {
    //     container.removeEventListener("mouseenter", onMouseEnter);
    //     container.removeEventListener("mouseleave", onMouseLeave);
    //   };
    // }

    const onResize = () => ensureScrollable();
    window.addEventListener("resize", onResize);

    return () => {
      if (animationRef.current) cancelAnimationFrame(animationRef.current);
      cleanup();
      window.removeEventListener("resize", onResize);
      if (container) container.style.minWidth = "";
    };
  }, [speed, pauseOnHover, forceMinWidth]);

  return scrollRef;
}